export const isAuthenticated = () => localStorage.getItem("token") !== null;
export const getToken = () => localStorage.getItem("token");
export const getRefreshToken = () => localStorage.getItem("refresh_token");

export const logout = () => {
	localStorage.removeItem("token");
	localStorage.removeItem("refresh_token");
};
